import React from 'react'

const FooterExtended = () => (
  <footer className='footer-extended qa-footer-extended'>
    <div className='footer-extended-container'>
      <a
        href='/ueber-yourfirm/'
        title='Über Yourfirm'
        className='footer-extended-text d-none d-sm-inline'
      >
        Über&nbsp;Yourfirm
      </a>
      <a
        href='/kontakt/'
        title='Kontakt'
        className='footer-extended-text d-none d-sm-inline'
      >
        Kontakt
      </a>
      <a
        href='/nutzungsbedingungen/'
        title='Nutzungsbedingungen'
        className='footer-extended-text d-none d-sm-inline'
      >
        Nutzungsbedingungen
      </a>
      <a
        href='/agb/'
        title='AGB'
        className='footer-extended-text'
      >
        AGB
      </a>
      <a
        href='/datenschutz/'
        title='Datenschutz'
        className='footer-extended-text'
      >
        Datenschutz
      </a>
      <a
        href='/impressum/'
        title='Impressum'
        className='footer-extended-text'
      >
        Impressum
      </a>
      <span className='footer-extended-text d-none d-sm-inline'>Fotocredit:&nbsp;Shutterstock</span>
    </div>
  </footer>
)

export default FooterExtended
